/** Modelo de precios (debe coincidir con Subscription.constants.ts del backend). */
export const PRICING = {
  basePrice: 450,
  extraSeatPrice: 250,
  includedSeats: 1,
  addons: { inventory: 0, loyaltyCards: 0, aiAssistant: 200 },
};

/** Etiquetas de los add-ons en el orden del catálogo (superadmin y Mi cuenta). */
export const ADDON_LABELS = {
  inventory: "Inventario",
  loyaltyCards: "Tarjetas de lealtad",
  aiAssistant: "Asistente con IA",
};

/**
 * Precio de lista del modelo por defecto del asistente (gpt-5-nano, USD por millón de
 * tokens, sep 2026), solo para el costo estimado del superadmin. Debe coincidir con
 * AI_COST_USD_PER_MTOKEN del backend.
 */
export const AI_COST_USD_PER_MTOKEN = { input: 0.05, output: 0.4 };
export const aiEstimatedCostUsd = (tokensIn, tokensOut) =>
  ((Number(tokensIn) || 0) * AI_COST_USD_PER_MTOKEN.input + (Number(tokensOut) || 0) * AI_COST_USD_PER_MTOKEN.output) / 1e6;

/** Periodo de gracia (debe coincidir con Subscription.constants.ts del backend). */
export const GRACE_PERIOD_DAYS = 5;

/**
 * Add-ons que entran con el próximo ciclo (debe coincidir con `nextCycleAddons` del
 * backend). Los cambios del superadmin se programan en `addonsNextCycle` y el cron del
 * back los vuelve vigentes en el corte (o en `addonsNextCycleAt`); sin cambios
 * programados son los mismos que hoy. Úsalo para todo lo que sea "cuánto va a pagar";
 * `subscription.addons` para "qué tiene hoy".
 */
export function nextCycleAddons(sub) {
  return sub?.addonsNextCycle || sub?.addons || {};
}

/** Hay un cambio de add-ons programado para el próximo pago. */
export function addonsChangePending(sub) {
  const now = sub?.addons || {};
  const next = nextCycleAddons(sub);
  return Object.keys({ ...now, ...next }).some((k) => !!now[k] !== !!next[k]);
}

export function computePrice(seats = 1, addons) {
  // `addons` llega como null desde GraphQL en clientes sin add-ons; el default
  // de parámetro solo cubre undefined.
  const a = addons || {};
  const extra = Math.max(0, (Number(seats) || 1) - PRICING.includedSeats);
  let total = PRICING.basePrice + extra * PRICING.extraSeatPrice;
  // Recorre el catálogo: un add-on nuevo solo se agrega a PRICING.addons (y a ADDON_LABELS).
  for (const key of Object.keys(PRICING.addons)) if (a[key]) total += PRICING.addons[key];
  return total;
}
